module.exports = __webpack_public_path__ + "static/media/visible-icon.a5acc9e4.svg";